import { useNavigate } from 'react-router';
import { Button, EmptyState, Stack } from '../ui';

/**
 * The catch-all route.
 *
 * @returns The not-found element.
 */
export function NotFoundPage(): React.JSX.Element {
  const navigate = useNavigate();

  return (
    <Stack gap="xl">
      <EmptyState
        title="Page not found"
        description="That address does not match anything in Greasemap."
        action={
          <Button variant="primary" onClick={() => void navigate('/')}>
            Back to home
          </Button>
        }
      />
    </Stack>
  );
}
